import React from "react";
import { Tab, Nav, Spinner } from "react-bootstrap";
import { faCheck, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Stepper.scss";

const Stepper = ({data, onChange}) => {
  return (
    <>
      <Tab.Container id="left-tabs-example" defaultActiveKey={data[0]?.done && data[0]?.key}>
        <Nav variant="pills" className="flex justify-content-center" >
          <div className="stepper-wrapper">
            {
              data.map((item) =>
                <>
                  <Nav.Item key={item.key} className="stepper-item">
                    <div className="step-counter">
                      <Nav.Link eventKey={item.key} disabled={!(item.status == "completed")} onClick={() => onChange(item.key)} className="stepper">
                        {item.status === "inprogress" ? (
                          <Spinner className="stepper-spinner" animation="border"/>
                        ) : item.status === "completed" ? (
                          <FontAwesomeIcon icon={faCheck} className="copy-icon" />
                        ) : item.status === "failed" ? (
                          <FontAwesomeIcon icon={faCircleExclamation} className="failed-icon" /> // Assuming `faTimes` represents a cross icon for "failed"
                        ) : (
                          item.label
                        )}
                      </Nav.Link>
                    </div>
                    <div className="stepper-label">
                      {item.name}
                    </div>
                  </Nav.Item>
                </>
              )
            }
          </div>
        </Nav>
      </Tab.Container>
    </>
  );
};

export default Stepper;